// One route registry for browser metadata, prerendering, sitemap and redirects.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://www.suryagroup.us').replace(/\/$/, '');
export const aliases = {
  '/services/insulation-&-moisture-protection': '/services/insulation-and-moisture-protection',
  '/services/openings-&-hardware': '/services/openings-and-hardware',
};
export function normalizePath(pathname) {
  let path;
  try { path = decodeURIComponent(pathname); } catch { return pathname; }
  path = path.toLowerCase().replace(/\/+$/, '') || '/';
  return aliases[path] || path;
}
export const pages = {
  "/": {
    "title": "Construction Estimating Company & Takeoffs | Surya Group",
    "description": "Construction estimating and material takeoff services for residential and commercial projects. Plan materials, labor costs and bids with Surya Group."
  },
  "/about": {
    "title": "About Our Construction Estimating Team | Surya Group",
    "description": "Learn about Surya Group, our estimating approach and the values behind our material takeoff and construction budgeting services across North America."
  },
  "/contact-us": {
    "title": "Contact Our Construction Estimating Team | Surya Group",
    "description": "Contact Surya Group about construction estimates, material takeoffs and project budgeting. Send your questions to our estimating team."
  },
  "/policy": {
    "title": "Privacy, Payment & Refund Policies | Surya Group",
    "description": "Read Surya Group’s privacy policy, terms of service, delivery timelines, and cancellation and refund policies for construction estimating services."
  },
  "/frequently-asked-questions": {
    "title": "Construction Estimating & Account FAQs | Surya Group",
    "description": "Find answers to questions about Surya Group support, accounts, payments, invoices and using our construction estimating platform."
  },
  "/blog": {
    "title": "Construction Estimating Blog & Insights | Surya Group",
    "description": "Explore Surya Group’s construction articles on contractor strategies, bidding and finishes, with links to the full articles on LinkedIn."
  },
  "/schedule-meeting": {
    "title": "Schedule a Construction Estimating Consultation | Surya Group",
    "description": "Book a free 30-minute online or phone consultation with Surya Group to discuss your construction project, estimates and material takeoffs."
  },
  "/login": {
    "title": "Client Portal Login | Surya Group",
    "description": "Access the Surya Group client portal for construction estimating projects and account services.",
    "noindex": true
  },
  "/registration": {
    "title": "Client Account Registration | Surya Group",
    "description": "Continue to Swiftboard to register your Surya Group client account.",
    "noindex": true
  },
  "/approve-user": {
    "title": "User Account Approval | Surya Group",
    "description": "Surya Group account approval and administration.",
    "noindex": true
  },
  "/material-takeoff-services": {
    "title": "Material Takeoff Services for Contractors | Surya Group",
    "description": "Construction material takeoff services for contractors. Explore trade quantities, learn how takeoffs differ from estimates and prepare your project request.",
    "service": "Construction Material Takeoff Services"
  },
  "/general-contractor": {
    "title": "General Contractor Estimating Services | Surya Group",
    "description": "Construction estimating support for general contractors. Plan multi-trade scopes, compare bids and request material takeoffs for your next project.",
    "service": "General Contractor Estimating Services"
  },
  "/services/flooring-estimation": {
    "title": "Flooring Estimating & Takeoff Services | Surya Group",
    "description": "Get flooring material takeoffs, area measurements and labor cost estimates for hardwood, tile, vinyl, carpet and other residential and commercial finishes.",
    "service": "Flooring Estimating & Takeoff Services"
  },
  "/services/drywall-estimation": {
    "title": "Drywall Estimating & Takeoff Services | Surya Group",
    "description": "Plan drywall projects with detailed material takeoffs and labor estimates for gypsum board, framing, insulation and finishing from Surya Group.",
    "service": "Drywall Estimating & Takeoff Services"
  },
  "/services/painting-estimation": {
    "title": "Painting Estimating & Takeoff Services | Surya Group",
    "description": "Get interior and exterior painting takeoffs covering surface areas, coatings, preparation and labor costs for residential and commercial projects.",
    "service": "Painting Estimating & Takeoff Services"
  },
  "/services/siding-estimation": {
    "title": "Siding Estimating & Takeoff Services | Surya Group",
    "description": "Estimate siding materials and labor with takeoffs for vinyl, fiber cement and wood, including trim, soffit and fascia for your construction project.",
    "service": "Siding Estimating & Takeoff Services"
  },
  "/services/lumber-estimation": {
    "title": "Lumber & Framing Takeoff Services | Surya Group",
    "description": "Get detailed lumber and framing takeoffs for studs, beams, joists, sheathing and hardware, with material quantities and labor cost estimates.",
    "service": "Lumber & Framing Takeoff Services"
  },
  "/services/concrete-estimation": {
    "title": "Concrete Estimating & Takeoff Services | Surya Group",
    "description": "Plan concrete work with volume calculations, reinforcement takeoffs and labor estimates for foundations, slabs and other structural concrete elements.",
    "service": "Concrete Estimating & Takeoff Services"
  },
  "/services/masonry-estimation": {
    "title": "Masonry Estimating & Takeoff Services | Surya Group",
    "description": "Get brick, block and stone masonry takeoffs with estimates for mortar, grout, reinforcement and labor for residential and commercial construction.",
    "service": "Masonry Estimating & Takeoff Services"
  },
  "/services/roofing-estimation": {
    "title": "Roofing Estimating & Takeoff Services | Surya Group",
    "description": "Get roofing takeoffs and cost estimates for shingles, metal, tile and membrane systems, including roof areas, accessories and installation labor.",
    "service": "Roofing Estimating & Takeoff Services"
  },
  "/services/insulation-and-moisture-protection": {
    "title": "Insulation & Waterproofing Estimating Services | Surya Group",
    "description": "Estimate insulation, vapor barriers and waterproofing systems with material takeoffs and labor costs for residential and commercial buildings.",
    "service": "Insulation & Waterproofing Estimating Services"
  },
  "/services/demolition-estimation": {
    "title": "Demolition Estimating & Takeoff Services | Surya Group",
    "description": "Plan demolition costs with structural and interior takeoffs, equipment estimates, disposal costs and hazardous material handling allowances.",
    "service": "Demolition Estimating & Takeoff Services"
  },
  "/services/electrical-estimation": {
    "title": "Electrical Estimating & Takeoff Services | Surya Group",
    "description": "Get electrical takeoffs and cost estimates covering wiring, panels, circuits and safety systems for residential and commercial construction projects.",
    "service": "Electrical Estimating & Takeoff Services"
  },
  "/services/mep-estimation": {
    "title": "MEP Estimating & Takeoff Services | Surya Group",
    "description": "Plan mechanical, electrical and plumbing work with coordinated material takeoffs and labor cost estimates from Surya Group.",
    "service": "MEP Estimating & Takeoff Services"
  },
  "/services/openings-and-hardware": {
    "title": "Door, Window & Hardware Takeoff Services | Surya Group",
    "description": "Get door, window and hardware takeoffs covering frames, hinges, locks, closers, thresholds and weather stripping for your construction project.",
    "service": "Door, Window & Hardware Takeoff Services"
  }
};
export const notFound = { title: '404 – Page Not Found | Surya Group', description: 'The requested page could not be found. Return to Surya Group to explore construction estimating services.', noindex: true };
